import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { Action } from '@ngrx/store';
import * as actions from '../actions/site';
import { SiteService } from '../services/site';
import { of } from 'rxjs/observable/of';
import { ListManagementService } from '../../core/services/list';
import * as routerActions from '../../core/actions/router';
import * as documentActions from '../../document/actions/document';
import * as auth from '../../core/actions/authentication';

@Injectable()

export class SiteEffects {

  @Effect()
  loadSiteList$: Observable<Action> = this.actions$
    .ofType(actions.LOAD_ALL_SITES)
    .switchMap(pm => {
      const nextLookup$ = this.actions$.ofType(actions.LOAD_ALL_SITES).skip(1);
      const errorMessage = 'Error loading sites.';
      return this.siteService.getSites()
        .takeUntil(nextLookup$)
        .map(p => new actions.LoadAllSitesCompleteAction(p))
        .catch(e => of({type: 'ERROR', payload: { error: e, message: errorMessage}}));
    });

    @Effect()
    loadFarmList$: Observable<Action> = this.actions$
      .ofType(actions.LOAD_ALL_FARMS)
      .switchMap(pm => {
        const nextLookup$ = this.actions$.ofType(actions.LOAD_ALL_FARMS).skip(1);
        const errorMessage = 'Error loading sites.';
        return this.siteService.getFarms()
          .takeUntil(nextLookup$)
          .map(p => new actions.LoadAllFarmsCompleteAction(p))
          .catch(e => of({type: 'ERROR', payload: { error: e, message: errorMessage}}));
      });

    @Effect()
    updateSite$: Observable<Action> = this.actions$
      .ofType(actions.UPDATE_SITE)
      .map((action: actions.UpdateSiteAction) => action.payload)
      .switchMap(pm => {
        const nextLookup$ = this.actions$.ofType(actions.UPDATE_SITE).skip(1);
        const errorMessage = 'Error loading sites.';
        return this.listService.manageItem(pm)
          .takeUntil(nextLookup$)
          .map(p => new actions.UpdateSiteCompleteAction(pm))
          .catch(e => of({type: 'ERROR', payload: { error: e, message: errorMessage}}));
      });

    @Effect()
    loadAuthorList$: Observable<Action> = this.actions$
      .ofType(actions.LOAD_AUTHORS)
      .switchMap(pm => {
        const nextLookup$ = this.actions$.ofType(actions.LOAD_AUTHORS).skip(1);
        const errorMessage = 'Error loading authors.';
        return this.siteService.getAuthors()
          .takeUntil(nextLookup$)
          .map(p => new actions.LoadAuthorsCompleteAction(p))
          .catch(e => of({type: 'ERROR', payload: { error: e, message: errorMessage}}));
      });

  @Effect()
  loadAocGps: Observable<Action> = this.actions$
    .ofType(actions.LOAD_AOC_GPS)
    .switchMap(pm => {
      const nextLookup$ = this.actions$.ofType(actions.LOAD_AOC_GPS).skip(1);
      const errorMessage = 'Error loading AOC Coordinates.';
      return this.siteService.getAocCoordinates()
        .takeUntil(nextLookup$)
        .map(p => new actions.LoadAocGpsCompleteAction(p))
        .catch(e => of({ type: 'ERROR', payload: { error: e, message: errorMessage } }));
    });

  @Effect()
  loadFarmGps: Observable<Action> = this.actions$
    .ofType(actions.LOAD_FARM_GPS)
    .switchMap(pm => {
      const nextLookup$ = this.actions$.ofType(actions.LOAD_FARM_GPS).skip(1);
      const errorMessage = 'Error loading Farm Coordinates.';
      return this.siteService.getFarmCoordinates()
        .takeUntil(nextLookup$)
        .map(p => new actions.LoadFarmGpsCompleteAction(p))
        .catch(e => of({ type: 'ERROR', payload: { error: e, message: errorMessage } }));
    });

    @Effect()
    updateSiteComplete$: Observable<Action> = this.actions$
      .ofType(actions.UPDATE_SITE_COMPLETE)
      .map(() => new routerActions.Go({ path: ['/admin', 'sites'] }));

    @Effect()
    removeDocumentComplete$: Observable<Action> = this.actions$
      .ofType(documentActions.REMOVE_DOCUMENT_COMPLETE)
    .map(() => new routerActions.Go({ path: ['/advancedsearch'] }));

  @Effect()
  loginComplete$: Observable<Action> = this.actions$
    .ofType(auth.LOGIN_COMPLETE)
    .map((action: auth.LoginCompleteAction) => action.payload)
    .switchMap(u => {
      if (u.changePw) {
        return of(new routerActions.Go({ path: ['changepassword'] }));
      } else {
        return of(new routerActions.Go({ path: ['admin'] }));
      }
    });

    constructor(private actions$: Actions,
      private siteService: SiteService,
      private listService: ListManagementService) {}
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/effects/site.ts